export default "__VITE_ASSET__BAydYb5U__"